export default {
  sm: `
    데이터센터 각 춘천은
    자연과 공존하며 기록을 보관하는
    ‘데이터의 궤(櫃)’입니다.
    <p class="sub-text">*궤(櫃) : 옷이나 물건을 넣는 네모난 통</p>
  `,
};
